
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/[solutionTitle]",
      function () {
        return require("private-next-pages/solutions/[solutionTitle].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/[solutionTitle]"])
      });
    }
  